<div id="modal-primary" class="manage-assignees">
  <div class="modal-overlay"
       [class.electron]="_electronService.isElectronApp"
       [class.active]="_toggle.categoryModal.getValue()"
       (visible)="_toggle.categoryModal.getValue()">
    <div class="modal-container">
      <div class="modal-content" (appClickOutside)="onClickOutsideGlobalPrimaryModal($event)" [class.electron]="_electronService.isElectronApp">
        <div class="global-close-btn right-side">
          <i class="icon-remove" (click)="_toggle.categoryModal.next(false); clickOutsideCounterModal = 1;"></i>
        </div>
        <h4 class="form-name colored">{{_locale.categoryModal.manage}}</h4>
        <div class="modal-content-box">
          <form [formGroup]="form" class="" (submit)="category ? update(form.value) : create(form.value)">
            <div class="form-colors">

            </div>
            <div class="form-grid full">
              <div class="form-grid-full">
                <div class="form-flex-input">
                  <input
                    type="text"
                    [placeholder]="_locale.categoryModal.categoryNamePlaceholder"
                    formControlName="name"
                  >
                  <button class="form-button btn-blue" type="submit">
                    {{category ? _locale.categoryModal.save : _locale.categoryModal.add}}
                  </button>
                </div>
              </div>
            </div>
            <div class="form-grid full" *ngFor="let category of categories; let i = index">
              <div class="form-grid-full">
                <div class="form-flex">
                  <div>
                    {{category.name}}
                  </div>
                  <div class="form-flex no-border">
                    <div class="remove" (click)="edit(category)">
                      <div class="icon-rounded clickable_link">
                        <i class="icon-edit"></i>
                      </div>
                    </div>
                    <div class="remove" (click)="delete(category)">
                      <div class="icon-rounded clickable_link">
                        <i class="icon-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-grid full margin_top">
              <div class="form-grid-full">
                <button
                  class="form-button btn-blue"
                  type="button"
                  (click)="clear(true)"
                >
                  {{_locale.categoryModal.clear}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
